import { render, staticRenderFns } from "./createClinic.vue?vue&type=template&id=4a086ade&"
import script from "./createClinic.vue?vue&type=script&lang=js&"
export * from "./createClinic.vue?vue&type=script&lang=js&"
import style0 from "./createClinic.vue?vue&type=style&index=0&id=4a086ade&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports